"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var owlCarousel = function () {
        $('.carousel').owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: false,
            autoplay: true,
            dots: true,
            loop: $('.content-wrapper__item').length > 2,
            responsive: {
                768: {
                    items: 1
                },
                1200: {
                    items: 2
                },
            }
        });
    };
    owlCarousel();
};
exports.init = init;
